var _style, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "inicio_cerrar_sesi\\xF3n",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27.7 27.7",
    style: {
      enableBackground: "new 0 0 27.7 27.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    className: "st0",
    d: "M10.4,24.2H5.8c-1.3,0-2.3-1-2.3-2.3c0,0,0,0,0,0V5.8c0-1.3,1-2.3,2.3-2.3c0,0,0,0,0,0h4.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    className: "st0",
    d: "M18.4,19.6l5.8-5.8l-5.8-5.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    className: "st0",
    d: "M24.2,13.8H10.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1487",
    className: "st1",
    d: "M0,0h27.7v27.7H0V0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutWhite);
export default __webpack_public_path__ + "static/media/logout_white.64a10cd70185bdf403beda31b28d0df9.svg";
export { ForwardRef as ReactComponent };